
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { adminApi } from "@/services/ApiService";
import { StandardProductName } from "@/api/api";
import { StandardProductRecord } from "./StandardProductRecord";

@Component
export default class StandardNameEdit extends Vue {
  @Prop()
  record!: StandardProductRecord;

  modalOpen: boolean = false;
  loading: boolean = false;
  names: StandardProductName[] = [];
  ownName: string = "";

  columns = [
    { title: "Namn", dataIndex: "name", key: "name" },
    { title: "Butiker", dataIndex: "stores", key: "stores", width: 100 },
  ];
  customRow = (record: StandardProductName) => ({
    on: {
      click: () => this.choose(record.name ?? ""),
    },
  });
  rowClassName = (record: StandardProductName) =>
    record.name === this.record.name ? "rowclass picked-row" : "rowclass";

  get moreNames() {
    return (this.record.nameCount ?? 0) - 1;
  }

  async openModal() {
    if (this.modalOpen) return;
    this.ownName = "";
    this.modalOpen = true;
    this.loading = true;
    try {
      let result = await adminApi.getStandardProductNames(this.record.plu ?? "");
      this.names = result.data.names ?? [];
    } finally {
      this.loading = false;
    }
  }

  useOwnName() {
    let name = this.ownName.trim();
    if (name) this.choose(name);
  }

  choose(name: string) {
    this.modalOpen = false;
    this.$emit("valueChanged", name);
  }

  modalCancel() {
    this.modalOpen = false;
  }
}
